import { Button, Card, Divider, Flex, Tag, Typography } from 'antd';
import { useOnboarding } from '../context/OnboardingContext';
import { useTelegram } from '../context/TelegramContext';
import { formatDateTime } from '../utils/format';
import { SUPPORT_LINK, openTelegramLink } from '../utils/telegramLink';

// TODO(owner): no Tribute "manage subscription" URL is exposed anywhere in the status response —
// this falls back to the same support contact used elsewhere in the app. Replace with a real
// Tribute management link once one is available (e.g. a bot deep link or tribute.tg URL).
const TRIBUTE_MANAGE_LINK = SUPPORT_LINK;

// ==============================|| TRIBUTE SUBSCRIPTION PANEL ||============================== //
//
// Read-only counterpart to `ClassicSubscriptionPanel` for subscribers whose `source` is `tribute`:
// no card, no schedule, no unsubscribe/pay-early actions — those are Click-only concepts that do
// not apply when the charge happens outside our system. Rendered in the same "Obunani boshqarish"
// slot on the vivid dashboard.

const TributeSubscriptionPanel = () => {
    const { subscriptionStatus } = useOnboarding();
    const { webApp } = useTelegram();

    return (
        <Flex vertical gap={16}>
            <Card className="info-panel" bordered={false}>
                <Flex justify="space-between" align="center" wrap gap={12}>
                    <div>
                        <Typography.Text className="muted-label">Holat</Typography.Text>
                        <Typography.Title level={4} className="section-title">
                            Faol
                        </Typography.Title>
                    </div>
                    <Tag color="success">Faol</Tag>
                </Flex>
                <Divider />
                <Typography.Paragraph className="section-text">
                    Obuna Tribute orqali boshqariladi.
                </Typography.Paragraph>
                <Typography.Paragraph className="section-text">
                    Amal qilish muddati: {formatDateTime(subscriptionStatus?.end_time)}
                </Typography.Paragraph>
            </Card>

            <Card className="info-panel" bordered={false}>
                <Typography.Title level={5} className="section-title">
                    Obunani boshqarish
                </Typography.Title>
                <Typography.Paragraph className="section-text">
                    Karta va to'lovlar Tribute bot orqali amalga oshiriladi. To'lovni bekor qilish yoki
                    o'zgartirish uchun Tribute bilan bog'laning.
                </Typography.Paragraph>
                <Button
                    block
                    href={TRIBUTE_MANAGE_LINK}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={(event) => openTelegramLink(webApp, TRIBUTE_MANAGE_LINK, event)}
                >
                    Qo'llab-quvvatlash
                </Button>
            </Card>
        </Flex>
    );
};

export default TributeSubscriptionPanel;
